var CardList = function () {

	var thisComp = this;

	this.init = function () {
		this.tabs();
		this.slider();

		loadMoreEvent();
	}

	this.tabs = function () {

		$('.tab-list li').on('click', function () {

			var tab_id = $(this).attr('data-tab');

			$(this).parent().find('li').removeClass('current');
			$(this).closest('[data-component="card-list"]').find('.tab-content').removeClass('current');

			$(this).addClass('current');
			$(this).closest('[data-component="card-list"]').find("." + tab_id).addClass('current');

			equalize();

			if ($(this).closest('[data-component="card-list"]').hasClass('solutions')) {
				try {
					$('[data-component="card-list"].solutions .card-content').slick('unslick');
					slickSolutions();
				}
				catch (e) { }
			}
			else if ($(this).closest('[data-component="card-list"]').hasClass('news')) {
				try {
					$('[data-component="card-list"].news .row').slick('unslick');
					slickNews();
				}
				catch (e) { }
			}
		});
	}

	this.slider = function () {

		if (window.innerWidth <= 640) {
			slickSolutions();
			slickNews();
		}

		$(window).on('resize', function (event) {

			try {
				if (event.target.innerWidth <= 640) {
					slickSolutions();
					slickNews();
				}
				else {
					unslickSolutions();
					unslickNews();
				}
			}
			catch (e) {
				console.log(e);
			}
		});
	}

	function slickSolutions() {

		$('[data-component="card-list"].solutions .card-content').each(function () {

			try {

				if ($(this).hasClass("no-slick") || $(this).hasClass("slick-initialized")) {
					return false;
				}

				if ($(this).children().length > 1) {
					$(this).slick({
						dots: true,
						infinite: true,
						arrows: false,
						slidesToShow: 1,
						adaptiveHeight: true,
						settings: "unslick"
					});
				}
			}
			catch (e) {
				console.log(e);
			}
		});
	}

	function slickNews() {

		$('[data-component="card-list"].news .card-content .row').each(function () {

			try {

				if ($(this).hasClass("no-slick") || $(this).hasClass("slick-initialized")) {
					return false;
				}

				if ($(this).children().length > 1) {
					$(this).slick({
						dots: true,
						infinite: true,
						arrows: false,
						slidesToShow: 1,
						unslick: true,
						adaptiveHeight: true
					});
				}
			}
			catch (e) {
				console.log(e);
			}
		});
	}

	function unslickSolutions() {

		$('[data-component="card-list"].solutions .card-content').each(function () {

			try {

				if ($(this).hasClass("slick-initialized")) {
					$(this).slick("unslick");
				}
			}
			catch (e) {
				console.log(e);
			}
		});
	}

	function unslickNews() {

		$('[data-component="card-list"].news .row').each(function () {

			try {

				if ($(this).hasClass("slick-initialized")) {
					$(this).slick("unslick");
				}
			}
			catch (e) {
				console.log(e);
			}
		});
	}

	var loadMoreEvent = function () {

		$("[data-component='card-list'] .loadMore").on("click", function (e) {

			e.preventDefault();

			var Component = $(this);
			var TabID = $(this).data("tab");
			var Limiter = $(this).data("limiter");
			var TotalAmount = $(this).parent().find(".card-content").find("[data-component='card-item']").length;

			Component.addClass('loading');

			$.ajax({
				type: "POST",
				url: "/umbraco/surface/CardList/LoadMore",
				data: JSON.stringify({ "TabID": TabID, "Limiter": Limiter, "TotalAmount": TotalAmount }),
				dataType: "json",
				async: true,
				contentType: "application/json; charset=utf-8",
				success: function (response) {

					Component.removeClass('loading');

					var html = "";

					if (response.CardList.length > 0) {

						html += "<div class='row row-flex'>";

						for (var i = 0; i < response.CardList.length; i++) {

							var item = response.CardList[i];

							switch (item.TemplateID) {

								case 1288: //Simple Card 3

									html += simpleCard3(item);

									break;

								case 1289: //Simple Card 4

									html += simpleCard4(item);

									break;

								case 1333: //Description Card 4 e Description Card Internal
								case 1571:
								case 1790:

									html += descriptionCard4(item);

									break;

								case 1332: //Description Card 6

									html += descriptionCard6(item);

									break;
							}
						}

						html += "</div>";
					}

					Component.parent().find(".card-content").append(html);
					TotalAmount = Component.parent().find(".card-content").find("[data-component='card-item']").length;
					equalize();

					if (TotalAmount >= response.CardsTotal) {
						Component.hide();
					}
				},
				error: function (e) {

				}
			});
		});
	};

	var simpleCard3 = function (card) {

		var html = "";

		html += '<div class="col-md-3 col-sm-6 col-xs-12">';
		html += '	<div data-component="card-item" class="flex">';
		html += '		<a href="' + card.URL + '">';
		html += '			<div class="img-holder">';
		html += '				<img src="' + card.Image + '" alt="' + card.ImageAltText + '">';
		html += '			</div>';
		html += '			<div class="content content-inner">';
		html += '				<div class="infos">';
		html += '					<h3 class="title">' + card.Title + '</h3>';
		html += '				</div>';
		html += '			</div>';
		html += '		</a>';
		html += '	</div>';
		html += '</div>';

		return html;
	};

	var simpleCard4 = function (card) {

		var html = "";

		html += '<div class="col-md-4 col-sm-6 col-xs-12">';
		html += '	<div data-component="card-item" class="flex">';
		html += '		<a href="' + card.URL + '">';
		html += '			<div class="img-holder">';
		html += '				<img src="' + card.Image + '" alt="' + card.ImageAltText + '">';
		html += '			</div>';
		html += '			<div class="content content-inner">';
		html += '				<div class="infos">';
		html += '					<h3 class="title">' + card.Title + '</h3>';
		html += '				</div>';
		html += '			</div>';
		html += '		</a>';
		html += '	</div>';
		html += '</div>';

		return html;
	};

	var descriptionCard4 = function (card) {

		var html = "";

		html += '<div class="col-md-4 col-sm-6 col-xs-12">';
		html += '	<div data-component="card-item">';
		html += '		<div class="img-holder">';
		html += '			<img src="' + card.Image + '" alt="' + card.ImageAltText + '">';
		html += '		</div>';
		html += '		<div class="content content-inner content-news">'
		html += '			<div class="infos">';
		html += '				<span class="type">' + card.TopText + '</span>';
		html += '				<h3 class="title">' + card.Title + '</h3>';
		html += '				<div class="description">';
		html += card.Description
		html += '				</div>';

		if (card.ButtonText) {
			html += '			<a href="' + card.URL + '" class="btn-more">' + card.ButtonText + '</a>';
		}

		html += '			</div>';
		html += '		</div>';
		html += '	</div>';
		html += '</div>';

		return html;
	};

	var descriptionCard6 = function (card) {

		var html = "";

		html += '<div class="col-md-12 col-sm-6 card-item">';
		html += '	<div data-component="card-item" class="exp-application side-content">';
		html += '		<div class="img-holder">';
		html += '			<img src="' + card.Image + '" alt="' + card.ImageAltText + '">';
		html += '		</div>';
		html += '		<div class="content content-inner content-news">'
		html += '			<div class="infos">';
		html += '				<span class="type">' + card.TopText + '</span>';
		html += '				<h3 class="title card6">' + card.Title + '</h3>';
		html += '					<div class="description card6">';
		html += card.Description
		html += '					</div>';

		if (card.ButtonText) {
			html += '				<a href="' + card.URL + '" class="btn-more">' + card.ButtonText + '</a>';
		}

		html += '			</div>';
		html += '		</div>';
		html += '	</div>';
		html += '</div>';

		return html;
	};

	return this.init();
}